import { FundCriteriaList } from './fundCriteria.constant';
import { FundCriteria } from '../../types/fundScreener.type';

// No filters applied and no criterion preselected by default.
export const defaultFundCriteria: FundCriteria[] = FundCriteriaList.map(
  (item) => ({
    ...item,
    selected: false,
    min: 0,
    max: 0,
    timeValue: item.timeOptions?.[0] || '',
    isInitial: true,
  }),
);